import { Outlet, useLocation } from "react-router";

import Navigationbar from "./Navigationbar";
import { MenuInfo } from "data";

export default function MonitoringLayout() {
    const monitoring = MenuInfo.CMMS;
    // const monitoring = MenuInfo.ROOT;
    // const report_dataroom = MenuInfo.CMMS_REPORT_DATAROOM;
    // const setting = MenuInfo.CMMS_MANAGEMENT;

    const fullpath = useLocation().pathname;
    const className1 = "";
    const className2 = "#FFF";
    // const className1 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? " white_ver" : "";
    // const className2 = (fullpath.indexOf(report_dataroom.fullpath) != -1 || fullpath.indexOf(setting.fullpath) != -1) ? "#000" : "#FFF";
    return (
        <div className={`monitering${className1}`}>
        {/* <div className={`monitering`}> */}
            <Navigationbar />
            <div className="mobile_navi" style={{color : `${className2}`}}>
            {/* <div className="mobile_navi" style={{color : "#FFF"}}> */}
                {
                    // (monitoring.children.find((child) => child.isActive).element.props.comment)
                    ((monitoring.children.find((child) => child.isActive) && monitoring.children.find((child) => child.isActive).fullpath === fullpath) ? monitoring.children.find((child) => child.isActive).element?.props?.comment : "")
                }
            </div>
            <Outlet/>
        </div>
    );
}
